import { graphql } from '@apollo/client/react/hoc'

import { ApplicationError } from '../../helpers/errors'
import query from './query.graphql'

export { query }

export const mapDataToProps = ({ data: { loading, error, centre } }) => {
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  }

  return {
    loading,
    centreCategories: centre && centre._backrefs.stores__via__centre,
  }
}

export const mapPropsToOptions = ({ centre }) => ({
  context: { version: 1 },
  variables: {
    centreID: centre.sys.id,
  },
})

const withStoreRetailCategories = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withStoreRetailCategories
